import { render, staticRenderFns } from "./DailyDeferredSales.vue?vue&type=template&id=2c2ab686&lang=pug"
import script from "./DailyDeferredSales.vue?vue&type=script&lang=js"
export * from "./DailyDeferredSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports